import createCache from '@emotion/cache';
import { CacheProvider } from '@emotion/react';
import RevolucciProvider from '@encodium/rp-ui/contexts/revoluccui-theme';

import { EMOTION_CACHE_KEY } from '../../../shared/islands/emotion-cache-key.mjs';

// One shared cache for every client island mount (Emotion's intended pattern); per-element styles
// are deduped by content hash, so multiple instances with different state never collide.
const cache = createCache({ key: EMOTION_CACHE_KEY });

/**
 * Client hydration tree matching SSR (`shared/islands/render-island-tree.mjs`).
 * @param {import('react').CreateElement} createElement
 * @param {import('react').ComponentType<Record<string, unknown>>} Component
 * @param {Record<string, unknown>} props
 * @returns {import('react').ReactElement}
 */
export function wrapIslandTree(createElement, Component, props) {
	return createElement(
		CacheProvider,
		{ value: cache },
		createElement(
			RevolucciProvider,
			null,
			createElement(Component, props),
		),
	);
}
